import React, { useState, useRef, useCallback } from 'react';

export function BeforeAfterSlider({ beforeSrc, afterSrc, alt }) {
  const [position, setPosition] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const updatePosition = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPosition((x / rect.width) * 100);
  }, []);

  const handleStart = useCallback((e) => {
    e.preventDefault();
    dragging.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updatePosition(clientX);
  }, [updatePosition]);

  const handleMove = useCallback((e) => {
    if (!dragging.current) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updatePosition(clientX);
  }, [updatePosition]);

  const handleEnd = useCallback(() => {
    dragging.current = false;
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative aspect-square rounded-lg overflow-hidden cursor-col-resize select-none touch-none"
      onMouseDown={handleStart}
      onMouseMove={handleMove}
      onMouseUp={handleEnd}
      onMouseLeave={handleEnd}
      onTouchStart={handleStart}
      onTouchMove={handleMove}
      onTouchEnd={handleEnd}
      data-testid="before-after-slider"
    >
      {/* After image (full) */}
      <img src={afterSrc} alt={`${alt} after`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      
      {/* Before image (clipped) */}
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${position}%` }}>
        <img src={beforeSrc} alt={`${alt} before`} className="absolute inset-0 w-full h-full object-cover" style={{ width: `${containerRef.current?.offsetWidth || 300}px`, maxWidth: 'none' }} draggable={false} />
      </div>

      {/* Slider handle */}
      <div className="absolute top-0 bottom-0" style={{ left: `${position}%`, transform: 'translateX(-50%)' }}>
        <div className="w-0.5 h-full bg-white shadow-lg" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5 3L1 8L5 13" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M11 3L15 8L11 13" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
      </div>

      {/* Labels */}
      <span className="absolute top-3 left-3 bg-black/60 text-white text-xs px-2 py-0.5 rounded pointer-events-none">Before</span>
      <span className="absolute top-3 right-3 bg-[#D4AF37] text-white text-xs px-2 py-0.5 rounded pointer-events-none">After</span>
    </div>
  );
}
